import React, { FC } from 'react';
import styled from 'styled-components';
import {
    SkeletonBlock,
    SkeletonFiltersRow,
    SkeletonPageHeader,
    SkeletonPageShell,
    SkeletonRow,
    SkeletonStack,
    SkeletonTable,
    SkeletonTableRow
} from 'src/components/widgets/skeleton';
import { SettingsFormPageSkeleton } from '../settings/settingsSkeleton';

const ProductsPageSkeletonShell = styled(SkeletonPageShell)``;

const ProductsPageSkeletonHeader = styled(SkeletonPageHeader)``;

const productsListTableColumns = '85px minmax(180px, 1.2fr) minmax(120px, 0.8fr) minmax(110px, 0.6fr) minmax(92px, 0.4fr) 86px';

const ProductsListOptionalCell = styled.div`
    @media (max-width: 700px) {
        display: none;
    }
`;

export const ProductsListPageSkeleton: FC<{ titleWidth?: string; actionWidth?: string }> = ({ titleWidth = '240px', actionWidth = '132px' }) => (
    <ProductsPageSkeletonShell aria-hidden='true'>
        <ProductsPageSkeletonHeader>
            <SkeletonStack $gap='8px' $flex='1'>
                <SkeletonBlock $width={`min(${titleWidth}, 100%)`} $height='26px' />
                <SkeletonBlock $width='min(460px, 100%)' $height='13px' />
            </SkeletonStack>
            {actionWidth && <SkeletonBlock $width={actionWidth} $height='36px' $radius='6px' />}
        </ProductsPageSkeletonHeader>
        <SkeletonFiltersRow searchWidth='300px' controlWidths={['214px']} />
        <SkeletonTable>
            <SkeletonTableRow $columns={productsListTableColumns} $minHeight='40px' $padding='9px 12px' $hideLastBorder={false}>
                <SkeletonBlock $width='1px' $height='12px' />
                <SkeletonBlock $width='46px' $height='12px' />
                <ProductsListOptionalCell>
                    <SkeletonBlock $width='36px' $height='12px' />
                </ProductsListOptionalCell>
                <ProductsListOptionalCell>
                    <SkeletonBlock $width='48px' $height='12px' />
                </ProductsListOptionalCell>
                <ProductsListOptionalCell>
                    <SkeletonBlock $width='42px' $height='12px' />
                </ProductsListOptionalCell>
                <SkeletonBlock $width='1px' $height='12px' />
            </SkeletonTableRow>
            {Array.from({ length: 8 }).map((_, index) => (
                <SkeletonTableRow
                    key={index}
                    $columns={productsListTableColumns}
                    $padding='6px 12px'
                    $minHeight='56px'
                    $mobileColumns='54px minmax(0, 1fr) 86px'
                >
                    <SkeletonBlock $width='40px' $height='40px' $radius='4px' />
                    <SkeletonStack $gap='8px'>
                        <SkeletonBlock $width={index % 2 === 0 ? '76%' : '58%'} $height='16px' />
                        <SkeletonBlock $width='42%' $height='12px' />
                    </SkeletonStack>
                    <ProductsListOptionalCell>
                        <SkeletonBlock $width={index % 2 === 0 ? '72%' : '54%'} $height='14px' />
                    </ProductsListOptionalCell>
                    <ProductsListOptionalCell>
                        <SkeletonBlock $width='92px' $height='20px' />
                    </ProductsListOptionalCell>
                    <ProductsListOptionalCell>
                        <SkeletonBlock $width='86px' $height='24px' $radius='12px' />
                    </ProductsListOptionalCell>
                    <SkeletonRow $gap='8px' $justify='flex-end'>
                        <SkeletonBlock $width='34px' $height='34px' $radius='6px' />
                        <SkeletonBlock $width='34px' $height='34px' $radius='6px' />
                    </SkeletonRow>
                </SkeletonTableRow>
            ))}
        </SkeletonTable>
    </ProductsPageSkeletonShell>
);

export const AdvancedPrintFileProductsPageSkeleton: FC = () => <ProductsListPageSkeleton titleWidth='260px' />;

export const PlacementProductPageSkeleton: FC = () => <SettingsFormPageSkeleton />;
